// Lib
import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';

// Utils
import randomString from '../../../common/uid/randomString';

// Hooks
import { useToastContext } from './ToastContext';

// Styles
import './Toast.scss';

interface ToastProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    className?: string;
}

const Toast: React.FC<ToastProps> = ({ className, children, ...props }) => {
    const toastId = useMemo(() => {
        const randStr = randomString(6);
        if (className) return `${className}-${randStr}`;
        return randStr;
    }, []);

    const { addToast, removeToast } = useToastContext();

    useEffect(() => {
        const component = (
            <div {...props} className={classNames('Toast', className)}>
                {children}
            </div>
        );

        addToast(toastId, component);

        return () => {
            removeToast(toastId);
        };
    }, []);

    return null;
};

export default Toast;
